import { render, staticRenderFns } from "./Canon.vue?vue&type=template&id=3584dc1d&"
import script from "./Canon.vue?vue&type=script&lang=js&"
export * from "./Canon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Canon.vue"
export default component.exports